module.exports = __webpack_public_path__ + "img/news-2.f47a11e7.png";